<div class="main-container">
    <div class="carnet-content row">
        <span style="font-size: large;">
            Ingrese la información del usuario a consultar
        </span>
        <br><br><br>
        <form [formGroup]="frmCarnet">
            <div class="form-container row">
                <div class="col-12 col-lg-3">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Tipo de Identificación</mat-label>
                        <mat-select name="docItem" formControlName="documentType">
                        @for (docItem of documentTypeData; track docItem) {
                            <mat-option [value]="docItem.acronym">{{ docItem.acronym }} - {{ docItem.name}}</mat-option>
                        }
                        </mat-select>
                        <mat-error *ngIf="hasError( getControl['documentType'] )">
                            {{ printError( getControl['documentType'] , {'required':'Ingrese el tipo de identificación'} ) }}
                        </mat-error>
                    </mat-form-field>
                </div>                
                <div class="col-12 col-lg-5">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Identificación</mat-label>
                        <input matInput type="number" formControlName="documentNumber" (keydown)="disableArrowKeys($event)">
                        <mat-error *ngIf="hasError( getControl['documentNumber'] )">
                            {{ printError( getControl['documentNumber'] , {'required':'Ingrese el número identificación'} ) }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-lg-4">                    
                    <button 
                    type="submit" 
                    class="btn btn-primary btn-icon" 
                    (click)="consultCarnet()"
                    appTrackClick
                    [trackData]="trackDataCarnet"
                    >
                        <mat-icon>search</mat-icon><span>CONSULTAR</span>
                    </button>
                </div>
            
            </div>
        </form>        
        <div *ngIf="haveDate">
            <div class="container responsive-grid">
                <mat-card class="card" *ngFor="let carnetItem of dsCarnet">
                    <!-- <mat-card-header class="card-header-carnet">
                        <mat-card-title class="card-title">{{ carnetItem.nombre }}</mat-card-title>
                        <mat-icon (click)="carnetItem.selected = !carnetItem.selected" class="icon-button-style">{{carnetItem.selected ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                    </mat-card-header> -->
                    <mat-card-header class="card-header-carnet">
                        <div class="card-title-container">
                            <mat-card-title class="card-title">{{ carnetItem.nombre }}</mat-card-title>
                        </div>
                        <div class="icon-button-container">
                            <mat-icon (click)="carnetItem.selected = !carnetItem.selected" class="icon-button-style">
                                {{carnetItem.selected ? 'check_circle' : 'radio_button_unchecked'}}
                            </mat-icon>
                        </div>
                    </mat-card-header>
                    
                    <br/>
                    <mat-card-content class="card-body">
                        <p>{{ carnetItem.identificacion }}</p>
                        <p>No. Contrato: {{ carnetItem.ContratoAfiliado }}</p>
                        <p>Usuario: {{ carnetItem.NumeroUsuario }}</p>
                        <p>Credencial: {{ carnetItem.credencial }}</p>
                        <p>Programa: {{ carnetItem.Plan }}</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="table-action-container row">
                <div class="col-12 col-lg-3 btn-container">
                    <button class="btn btn-primary" (click)="generateData(1)">GENERAR</button>                
                </div>
                <div class="col-12 col-lg-3 btn-container">
                    <button class="btn btn-primary" (click)="generateData(2)">GENERAR Y ENVIAR</button>
                </div>
            </div>
            <div style="text-align: center;">
                <span class="message-span"> {{ generalMessage.toUpperCase() }}</span>
            </div>
        </div>
            <!--
            <table mat-table [dataSource]="dsCarnet" class="mat-elevation-z8 demo-table">            
                @for (column of columns; track column) {
                <ng-container [matColumnDef]="column.columnDef">
                    <container-element [ngSwitch]="column.columnDef">
                        <ng-container *ngSwitchCase="'actions'">
                            <ng-container>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    A{{ column.header }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox color="primary" [checked]="element._sel" (change)="itemSelected($event.checked,element)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                        </ng-container>
                        <some-element *ngSwitchDefault>
                            <ng-container>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{ column.header }}
                                </th>
                                <td mat-cell *matCellDef="let row"> 
                                    {{ column.cell(row) }}
                                </td>
                            </ng-container>
                        </some-element>
                    </container-element>
                </ng-container>
                }
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table> -->
        
        <div *ngIf="!haveDate" class="message-container">
            <span class="message-span"> {{ generalMessage.toUpperCase() }}</span>
        </div>
    </div>
</div>